import isClient from 'commons/isClient';
import loadAffirmScript, {
  AFFIRM_LOAD_STRATEGY,
} from 'commons/loadAffirmScript';
import refreshFinancingContent from 'commons/refreshFinancingContent';
import poll from 'commons/poll';

const getAffirmLink = affirmButtonRef =>
  affirmButtonRef?.current?.querySelector?.('a,button');

const ensureAffirmModalReady = affirmButtonRef =>
  new Promise((resolve, reject) => {
    if (!isClient()) {
      reject(new Error('Affirm modal is only available in the browser'));
      return;
    }

    const existingLink = getAffirmLink(affirmButtonRef);
    if (existingLink) {
      resolve(existingLink);
      return;
    }

    loadAffirmScript(
      () => {
        refreshFinancingContent();
      },
      { loadStrategy: AFFIRM_LOAD_STRATEGY.IMMEDIATE }
    );

    poll({
      condition: () => !!getAffirmLink(affirmButtonRef),
      callback: () => resolve(getAffirmLink(affirmButtonRef)),
      errorCallback: () =>
        reject(new Error('Affirm modal link not ready in time')),
      interval: 100,
      maxRetries: 100,
    });
  });

export default ensureAffirmModalReady;
